import { useState, useEffect, useRef } from "react";

const useFormFields = (initialData) => {
  const [title, setTitle] = useState(initialData?.title || "");
  const [description, setDescription] = useState(
    initialData?.description || ""
  );
  const [fundingGoal, setFundingGoal] = useState(initialData?.fundingGoal || 0);
  const [digitalSupply, setDigitalSupply] = useState(initialData?.digitalSupply || 1);

  const [tags, setTags] = useState(initialData?.tags || []);

  // Use a ref to track if it's the first render
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current && initialData) {
      setTitle(initialData.title || "");
      setDescription(initialData.description || "");
      setFundingGoal(initialData.fundingGoal || 5);
      setDigitalSupply(initialData.digitalSupply || 1);

      setTags(initialData.tags || []);
      isFirstRender.current = false; // Set to false after initial load
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData]); // Keep initialData in the dependency array

  return {
    title,
    setTitle,
    description,
    setDescription,
    fundingGoal,
    setFundingGoal,
    digitalSupply,
    setDigitalSupply,
    tags,
    setTags,
  };
};

export default useFormFields;
